// assets/oos-bridge.js
(function(){
  const API_URL = 'https://guitarbrothers.theexplorer.com.au/api/check.php'; // adjust path if needed

  function select(el, sel){ return (el || document).querySelector(sel); }
  function disable(btn, text){ if(!btn) return; btn.disabled = true; if(text) btn.dataset.originalText = btn.textContent, btn.textContent = text; }
  function enable(btn, text){ if(!btn) return; btn.disabled = false; btn.querySelector('span').textContent = text || btn.dataset.originalText || btn.textContent; }

  async function checkSku(sku){
    const url = `${API_URL}?sku=${encodeURIComponent(sku)}`;
    const res = await fetch(url, { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
    if(!res.ok) throw new Error('check failed');
    return res.json();
  }

  async function maybeEnableATC(productFormEl){
    const atcBtn = select(productFormEl, 'button[type="submit"], [name="add"]');
    const skuEl = select(productFormEl, '[data-variant-sku]');
    const oosBadge = select(productFormEl, '[data-oos-bridge-badge]');
    
    if(!skuEl) return;

    const sku = skuEl.value;

    if(!sku) return;
    try {
      const data = await checkSku(sku);
      if (data.enable_add_to_cart === true) {
        if (oosBadge) { 
        enable(atcBtn, 'Add to cart');

          if(!document.querySelector('.supplier-property')){
              const form = document.querySelector('product-form form');
              const newInput = document.createElement('input');
              newInput.type = 'hidden';
              newInput.name = 'properties[Supplier Order]';
              newInput.value = 'Yes';
              newInput.classList.add('supplier-property');
              
              form.appendChild(newInput);
          }
          oosBadge.textContent = 'Ships from supplier'; oosBadge.style.display = 'block';oosBadge.style.textAlign = 'center'; 
        }
      } else {
        // keep theme defaults
      }
    } catch(e){
      // fail quietly — do not break the product page
      console.warn('[oos-bridge] error', e);
    }
  }

  function onVariantChange(productFormEl){
    productFormEl.addEventListener('change', (e)=>{
      // Debounce a bit
      clearTimeout(productFormEl.__oosTimer);
      productFormEl.__oosTimer = setTimeout(()=> maybeEnableATC(productFormEl), 120);
    });
  }

  function init(){
    document.querySelectorAll('[data-oos-bridge-form]').forEach(form => {
      // First pass on load
      console.log(form);
      maybeEnableATC(form);
      // Re-run on any option change
      onVariantChange(form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();